import { render } from "./AccountSvg.vue?vue&type=template&id=2b5811cc"
import script from "./AccountSvg.vue?vue&type=script&lang=ts"
export * from "./AccountSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script